/**
 * Пробегается по дереву с переданным callback и возвращает изменное дерево по callback
 * @param {Array} items
 * @param {Function} callback
 * @returns {Array}
 */
function walker(items, callback) {
    items.forEach((item) => {
        callback(item);
        if (item.items && item.items.length) {
            walker(item.items, callback);
        }
    });
    return items;
}

/**
 * Возвращает узлы родители которых не выбраны
 * @param {Array} selectedItems
 * @returns {Array}
 */
function getSelectedItemsWithoutSelectedParent(selectedItems) {
    const parentSelectedMap = selectedItems.reduce((map, item) => {
        if (item.items && item.items.length) {
            map[item.id] = true;
        }

        return map;
    }, {});

    return selectedItems.filter((item) => {
        return !parentSelectedMap[item.parent];
    });
}

/**
 * Сортирует дерево возвращает отсортированное дерево
 * @param {Array} items
 * @param {Function} compareFunction
 * @returns {Array}
 */
function sort(items, compareFunction) {
    items.sort(compareFunction);
    return walker(items, (item) => {
        if (item.items && item.items.length) {
            item.items.sort(compareFunction);
        }
    });
}

export default {
    walker,
    getSelectedItemsWithoutSelectedParent,
    sort,
};
